
class storiesList {
	constructor() {
        this.listPagination();
        this.storySearchFilter();
        this.resetFilter();
    }
    getAllUrlParams(url) {

        // get query string from url (optional) or window
        var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

        // we'll store the parameters here
        var obj = {};

        // if query string exists
        if (queryString) {

            // stuff after # is not part of query string, so get rid of it
            queryString = queryString.split('#')[0];

            // split our query string into its component parts
            var arr = queryString.split('&');

            for (var i = 0; i < arr.length; i++) {
                // separate the keys and the values
                var a = arr[i].split('=');

                // set parameter name and value (use 'true' if empty)
                var paramName = a[0];
                var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

                // (optional) keep case consistent
                paramName = paramName.toLowerCase();
                if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

                // if the paramName ends with square brackets, e.g. colors[] or colors[2]
                if (paramName.match(/\[(\d+)?\]$/)) {

                    // create key if it doesn't exist
                    var key = paramName.replace(/\[(\d+)?\]/, '');
                    if (!obj[key]) obj[key] = [];

                    // if it's an indexed array e.g. colors[2]
                    if (paramName.match(/\[\d+\]$/)) {
                        // get the index value and add the entry at the appropriate position
                        var index = /\[(\d+)\]/.exec(paramName)[1];
                        obj[key][index] = paramValue;
                    } else {
                        // otherwise add the value to the end of the array
                        obj[key].push(paramValue);
                    }
                } else {
                    // we're dealing with a string
                    if (!obj[paramName]) {
                        // if it doesn't exist, create property
                        obj[paramName] = paramValue;
                    } else if (obj[paramName] && typeof obj[paramName] === 'string'){
                        // if property does exist and it's a string, convert it to an array
                        obj[paramName] = [obj[paramName]];
                        obj[paramName].push(paramValue);
                    } else {
                        // otherwise add the property
                        obj[paramName].push(paramValue);
                    }
                }
            }
        }

        return obj;
    }

    setURLParameter(key,value) {
        var queryParams = new URLSearchParams(window.location.search);
        queryParams.set(key, value);
        history.pushState(null, null, "?" + queryParams.toString());
    }

    deleteParameter(key)
    {
      var queryParams = new URLSearchParams(window.location.search);
      queryParams.delete(key);

      history.pushState(null, null, "?" +queryParams.toString());
    }

		getUrlParameter(value) {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        return urlParams.get(value);
    }

    listPagination() {

        $(document).on( 'click','.pagination a',(e) =>  {
            e.preventDefault();
            var elem = $(e.currentTarget);
            var url_string = elem.attr( 'href' );
            var searchVal = $('.form-search').find("input[name='search']").val();

            var paged = 1;
            if ( url_string ) {
                 paged =this.getAllUrlParams(url_string).pages;
            }
            this.setURLParameter('pages',paged);


            let ppr = $( '.stories-page-attributes' ).attr( 'data-ppr' );
            var value = $('.stories-page-attributes').val(); //retrieve array
            let currentUrl = $( '.stories-page-attributes' ).attr( 'currentUrl' );
            value = JSON.parse(value);

            var data = {
                'ppr' : ppr,
                'pages' : paged,
                'value' : value,
                'search' : searchVal,
                'action': 'dwd_story_pagination',
                'currentUrl' : currentUrl,
            }
						//console.log(data);
            $.ajax({
                url: dwd_object.ajaxurl,
                data: data,
                type: 'POST',
                success: function success(response) {
                    if (searchVal){
                        $( '.search-results__container .row' ).html( response.html );
                        $( '.search-results__container .pagination' ).html( response.pagination );
                    }else{
                    $( '.stories__results' ).html( response.html );
                    $( '.pagination' ).html( response.pagination );
                    }

                },
            });
						$('html, body').animate({
						  scrollTop: $(".stories__all-story").offset().top
						}, 400);
						// setTimeout(() => {
            //   $(window).scrollTop(0);
            // }, 400);
        });
    }

    storySearchFilter() {

        $(document).on('keypress', '.search-filter__js', (e) => {
            if ( e.code == 'Enter' ) {
                var elem = $(e.currentTarget),
                    searchVal = elem.val();
                $( '.storyfilter__val' ).attr( 'data-search-val', searchVal );
                if( searchVal != ''){
                    $('.form-search .form-search-reset').parents('.form-group').toggleClass('searched');
                }
				this.deleteParameter('pages');
                this.setURLParameter('search', searchVal);
                //var paged = 1;
                //this.setURLParameter('paged',paged);

                let ppr = $( '.storyfilter__val' ).attr( 'data-ppr' );

                var data = {
                    'ppr' : ppr,
                    'search' : searchVal,
                    //'paged' : paged,
                    'action': 'dwd_story_search',

                }
                $.ajax({
                    url: dwd_object.ajaxurl,
                    data: data,
                    type: 'POST',
                    success: (response) => {
                        //console.log(response.pagination)
                        $( '.search-results__js' ).html( response.html );
                        $( '#story' ).hide();
                        $( '.search-results__js' ).show();
                        $( '.search-results__js .pagination' ).html( response.pagination );

                    }
                });


            }
        });

        $(document).on('click', '.form-search-submit', (e) => {
            var searchVal = $('.search-filter__js').val();
            if( searchVal != ''){
                $('.storyfilter__val').attr('data-search-val', searchVal);

                $('.form-search .form-search-reset').parents('.form-group').toggleClass('searched');
                this.deleteParameter('pages');
                this.setURLParameter('search', searchVal);
                //var paged = 1;
                //this.setURLParameter('paged',paged);

                let ppr = $( '.storyfilter__val' ).attr( 'data-ppr' );

                var data = {
                    'ppr' : ppr,
                    'search' : searchVal,
                    //'paged' : paged,
                    'action': 'dwd_story_search',

                }
                $.ajax({
                    url: dwd_object.ajaxurl,
                    data: data,
                    type: 'POST',
                    success: (response) => {
                        //console.log(response.pagination)
                        $( '.search-results__js' ).html( response.html );
                        $( '#story' ).hide();
                        $( '.search-results__js' ).show();
                        $( '.search-results__js .pagination' ).html( response.pagination );

                    }
                });
            }
        });
    }

    resetFilter() {
        $( document ).on( 'click', '.reset__js', () => {
            $( '.search-filter__js' ).val( '' );
            $( '.storyfilter__val' ).attr( 'data-search-val', '' );
            $('.form-search .form-search-reset').parents('.form-group').toggleClass('searched');
			this.deleteParameter('search');
			this.deleteParameter('pages');
			//const paged = this.getUrlParameter('pages');
            let ppr = $( '.storyfilter__val' ).attr( 'data-ppr' );

            var data = {
                'ppr' : ppr,
                'pages' : 1,
                'search' : '',
                'action': 'dwd_story_search',
            }
            $.ajax({
                url: dwd_object.ajaxurl,
                data: data,
                type: 'POST',
                success: (response) => {
                    $( '.search-results__js' ).hide();
                    $( '#story' ).show();
                }
            });

        });
    }

}
new storiesList();
